import React from 'react';
import { ViewComfyIcon } from 'components/Icons/ViewComfyIcon';
import TollIcon from '@mui/icons-material/Toll';

export type routeType = {
  to: string;
  title: string;
  icon: Nullable<React.ComponentType>;
  nested?: routeType[] | null;
  publicRoute?: boolean;
  groupKey?: string;
  protectedRoute?: boolean;
  friendlyRoute?: boolean;
};

export const routes: routeType[] = [
  {
    to: '/reports/boards',
    title: 'Board Reports',
    icon: ViewComfyIcon,
    nested: null,
    publicRoute: false,
    groupKey: 'Reports',
    protectedRoute: true,
  },
  {
    to: '/reports/o2o',
    title: 'O2O',
    icon: TollIcon,
    nested: null,
    publicRoute: false,
    groupKey: 'Reports',
    protectedRoute: true,
    friendlyRoute: true,
  },
  {
    to: '/reports/o2oMini',
    title: 'O2O MINI',
    icon: TollIcon,
    nested: null,
    publicRoute: false,
    groupKey: 'Reports',
    protectedRoute: true,
    friendlyRoute: true,
  },
  {
    to: '/reports/footfall',
    title: 'Footfall',
    icon: TollIcon,
    nested: null,
    publicRoute: false,
    groupKey: 'Reports',
    protectedRoute: true,
    friendlyRoute: true,
  },
  {
    to: '/preview',
    title: 'Preview',
    icon: null,
    nested: null,
    publicRoute: true,
  },
  {
    to: '/preview/',
    title: 'Board Client Preview',
    icon: null,
    nested: null,
    publicRoute: true,
  },
];
